<template>
  <div :class="className" class="card-title">
    {{title}}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.card-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #191919;
  line-height: 22px;
}
</style>
